module.exports = __webpack_public_path__ + "img/cw_yf_caiWuYingFu.06b3e204.svg";